import React, { useState, useEffect } from 'react';
import api from '../../../services/api';

const LegacyPreview = ({ isAdminPreview = true }) => {
  const [data, setData] = useState({ section: null, items: [] });
  const [loading, setLoading] = useState(true);

  const fetchData = async () => {
    try {
      const [sectionRes, itemsRes] = await Promise.all([
        api.get('/business/legacy/section/').catch(() => ({ data: {} })),
        api.get('/business/legacy/'),
      ]);
      setData({
        section: sectionRes.data || {},
        items: itemsRes.data || []
      });
    } catch (err) {
      console.error('Error fetching legacy preview:', err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
    if (isAdminPreview) {
      const interval = setInterval(fetchData, 2000);
      return () => clearInterval(interval);
    }
  }, [isAdminPreview]);

  if (loading) {
    return (
      <div style={{ padding: '2rem', textAlign: 'center' }}>
        <div style={{
          width: '2rem', height: '2rem',
          border: '3px solid rgba(255,255,255,0.1)',
          borderTopColor: '#6366f1',
          borderRadius: '50%',
          animation: 'spin 1s linear infinite',
          margin: '0 auto'
        }} />
      </div>
    );
  }

  if (!data.items.length) {
    return (
      <div style={{
        padding: '2rem',
        textAlign: 'center',
        color: 'rgba(255,255,255,0.5)',
        backgroundColor: '#0f172a',
        minHeight: '200px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      }}>
        No legacy items added yet.
      </div>
    );
  }

  return (
    <div style={{ padding: '1.5rem', backgroundColor: '#0f172a', minHeight: '200px' }}>
      <h2 style={{ fontSize: '1.25rem', fontWeight: '700', color: '#fff', textAlign: 'center', marginBottom: '1.5rem' }}>
        {data.section?.title || 'Our Legacy'}
      </h2>
      <div style={{ position: 'relative', maxWidth: '500px', margin: '0 auto' }}>
        <div style={{
          position: 'absolute',
          left: '0.75rem',
          top: 0,
          bottom: 0,
          width: '2px',
          backgroundColor: 'rgba(99, 102, 241, 0.3)'
        }} />
        {data.items.slice(0, 4).map((item, index) => (
          <div key={item.id || index} style={{ display: 'flex', gap: '1rem', marginBottom: '1rem', position: 'relative' }}>
            <div style={{
              width: '1.5rem',
              height: '1.5rem',
              backgroundColor: '#6366f1',
              borderRadius: '50%',
              flexShrink: 0,
              zIndex: 1
            }} />
            <div style={{ flex: 1 }}>
              {item.year && (
                <span style={{
                  display: 'inline-block',
                  padding: '0.125rem 0.5rem',
                  backgroundColor: 'rgba(99, 102, 241, 0.2)',
                  color: '#6366f1',
                  borderRadius: '999px',
                  fontSize: '0.7rem',
                  fontWeight: '600',
                  marginBottom: '0.25rem'
                }}>
                  {item.year}
                </span>
              )}
              <h3 style={{ color: '#fff', fontSize: '0.875rem', fontWeight: '600', marginBottom: '0.25rem' }}>
                {item.title}
              </h3>
              <p style={{ color: 'rgba(255,255,255,0.6)', fontSize: '0.75rem', lineHeight: '1.5' }}>
                {item.description}
              </p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default LegacyPreview;
